<template>
  <div class="container">
    <div class="gutter">
      <h1
        class="title is-1"
        style="margin-bottom: 32px !important"
      >
        Playlists
      </h1>
      <h4 class="title is-4 text color-bluegrey3">
        All playlists
      </h4>
      <div class="columns">
        <playlist-hero-item
          v-for="playlist in heroPlaylists"
          :key="'hero' + playlist.pk"
          class="column"
          :playlist="playlist"
        />
      </div>
      <div class="columns is-desktop is-multiline">
        <playlist-list-item
          v-for="playlist in standardPlaylists"
          :key="playlist.pk"
          class="column is-one-third"
          :playlist="playlist"
        />
      </div>
    </div>
  </div>
</template>

<script>
import playlistClient from '@/api/playlists.js'
import PlaylistListItem from '@/components/PlaylistListItem.vue'
import PlaylistHeroItem from '@/components/PlaylistHeroItem.vue'

export default {
  name: 'PlaylistList',

  components: {
    PlaylistListItem,
    PlaylistHeroItem
  },

  data () {
    return {
      playlists: []
    }
  },

  computed: {
    standardPlaylists: function () {
      return this.playlists.filter(playlist => playlist.is_hero === false)
    },

    heroPlaylists: function () {
      return this.playlists.filter(playlist => playlist.is_hero === true)
    }
  },

  created () {
    playlistClient.listAll()
      .then((data) => {
        this.playlists = data
      })
  },

  metaInfo () {
    let url = window.location.origin
    const path = this.$route.path
    if (path !== '/') {
      url += path
    }
    const title = 'Curated Playlists | Real Music Licensing'
    const description = 'Find the perfect track for your video content through our handpicked collection of playlists.'

    return {
      title,
      meta: [
        { name: 'description', content: description },
        { property: 'og:url', content: url },
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
        { property: 'og:image', content: '/img/sonata-meta.png' },
        { name: 'twitter:card', content: 'website' }
      ]
    }
  }
}
</script>

<style lang="scss">

</style>
